<template>
  <div>
    <v-data-table
      :headers="computedHeaders"
      :items="eventsDisplay"
      item-key="meta.id"
      multi-sort
      sort-by="duration.start.firebaseFormat"
      :sort-desc="false"
      :footer-props="footerProps"
      :items-per-page="25"
      class="elevation-2"
      item-class="class"
      :dense="dense"
      max-height="800px auto"
      no-data-text="Keine Veranstaltungen vorhanden"
      :loading="loading"
      @click:row="openItem"
    >
      <template v-slot:top>
        <slot name="header"></slot>
      </template>
      <template v-slot:[`item.userResponse`]="{ item }">
        <v-avatar
          :color="statusColorAsHex(item.userResponse.status.id)"
          size="24"
          rounded
        >
          <v-icon small dark>
            {{ statusIcon(item.userResponse.status.id) }}
          </v-icon>
        </v-avatar>
      </template>
      <template v-slot:[`item.duration.start.firebaseFormat`]="{ item }">
        {{ item.duration.start.timestamp }}
      </template>
      <template v-slot:[`item.location.name`]="{ item }">
        <v-icon v-if="textIsUrl(item.location.name)" x-small
          >mdi-link-variant</v-icon
        >
        {{
          textIsUrl(item.location.name)
            ? getHostname(item.location.name)
            : item.location.name
        }}
      </template>
      <template v-slot:[`item.responses`]="{ item }">
        <response-statistics-card
          v-if="checkFeatureAvability"
          small
          marginClass="my-1"
          :totalConfirmations="item.count.totalConfirmations"
          :totalIfNecessary="item.count.totalIfNecessary"
          :totalCancellations="
            item.count.totalCancellations + item.count.totalAway
          "
          :totalResponses="item.count.totalResponses"
        ></response-statistics-card>
      </template>
      <!-- <template v-slot:no-data>
        <div
          style="
            height: 300px;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <p class="subtitle-1">Keine Veranstaltungen vorhanden</p>
        </div>
      </template> -->
    </v-data-table>
  </div>
</template>

<script>
// import { Timestamp } from "@/firebase.js";
// import { SCHEDULING_EVENTS_RESPONSES_write } from "@/data/permission-types.js";
import ResponseStatisticsCard from "@/components/scheduling/ResponseStatisticsCard.vue";
import { SCHEDULING_EVENTS_RESPONSES_OWN_update } from "@/data/permission-types.js";
export default {
  name: "events-data-table",
  props: {
    events: {
      required: true,
    },
    hideResponsesSummary: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: { ResponseStatisticsCard },
  data() {
    return {
      footerProps: {
        "items-per-page-options": [25, 50, 100, -1],
      },
      headers: [
        {
          text: "Status",
          sortable: false,
          value: "userResponse",
          permissions: [`${SCHEDULING_EVENTS_RESPONSES_OWN_update}`],
          width: "1%",
          divider: true,
          align: "center",
        },
        { text: "Veranstaltungstitel", value: "title", divider: true },
        { text: "Veranstaltungsart", value: "type.title", divider: true },
        {
          text: "Startzeitpunkt",
          value: "duration.start.firebaseFormat",
          divider: true,
        },
        {
          text: "Endzeitpunkt",
          value: "duration.end.timestamp",
          sortable: false,
          divider: true,
        },
        { text: "Ort", value: "location.name", divider: true },
      ],
    };
  },
  //   model: {
  //     prop: "response",
  //     event: "responseChange",
  //   },
  computed: {
    computedHeaders() {
      let headers = this.headers.filter(
        (p) => !p.permissions || !this.checkMultiplePermissions(p.permissions)
      );

      if (this.checkFeatureAvability && !this.hideResponsesSummary) {
        headers.push({
          text: "Rückmeldungen",
          value: "responses",
          sortable: false,
        });
      }
      return headers;
    },
    eventsDisplay() {
      return this.events.map((item) => {
        return {
          ...item,
          class:
            item.status === "canceled" || item.status === "postponed"
              ? "canceled-event"
              : "",
        };
      });
    },
    checkFeatureAvability() {
      return this.$store.getters["organization/checkFeatureAvailabilityById"](
        "showEventResponsesCount"
      );
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.mode === "manage") {
        this.baseHeaders.push({
          text: "Aktionen",
          value: "actions",
          align: "right",
          width: "1%",
          sortable: false,
        });
      }
    },
    textIsUrl(text) {
      // if text is url
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return urlRegex.test(text);
    },
    getHostname(url) {
      return new URL(url).hostname;
    },
    checkMultiplePermissions(items) {
      if (items && items.length > 0) {
        return false;
      } else {
        //return true;
        return this.$store.getters["organisation/checkPermissionByMultipleIds"](
          items
        );
      }
    },

    openItem(item) {
      this.$router.push({
        name: "scheduling-event-details-tab-general",
        params: {
          organizationId: this.$route.params.organizationId,
          itemId: item.meta.id,
        },
      });
    },
    statusIcon(item) {
      switch (item) {
        case "-0":
          return "mdi-cancel";
        case "0":
          return "mdi-help";
        case "1":
          return "mdi-check";
        case "2":
          return "mdi-close";
        case "3":
          return "mdi-minus";
        case "4":
          return "mdi-airplane";
        case "":
          return "mdi-alert-outline";
        default:
          return "";
      }
    },
    statusColorAsHex(item) {
      switch (item) {
        case "-0":
          return "#7B1FA2";
        case "0":
          return "#455a64";
        case "1":
          return "#4caf50";
        case "2":
          return "#ff5252";
        case "3":
          return "#fb8c00";
        case "4":
          return "#2196f3";
        case "":
          return "#455a64";
        default:
          return "";
      }
    },
  },
};
</script>

<style>
.parent-tr {
  height: 80px;
}
.canceled-event {
  background-image: repeating-linear-gradient(
    45deg,
    var(--canceled-event-light, #eeeeee),
    var(--canceled-event-light, #eeeeee) 10px,
    var(--canceled-event-dark, #fafafa) 10px,
    var(--canceled-event-dark, #fafafa) 20px
  );
}

@media (prefers-color-scheme: dark) {
  .canceled-event {
    background-image: repeating-linear-gradient(
      45deg,
      var(--canceled-event-dark, #424242),
      var(--canceled-event-dark, #424242) 10px,
      var(--canceled-event-darker, #757575) 10px,
      var(--canceled-event-darker, #757575) 20px
    );
  }
}
</style>
